import { Inject, Injectable, PLATFORM_ID, makeStateKey, TransferState } from '@angular/core';

import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { isPlatformServer } from '@angular/common';

import { Category } from '../models/category';
import { ListingService } from './listing-page.service';

@Injectable({
  providedIn: 'root',
})
export class HomeLastaddedResolverService  {
  constructor(
    private listingService: ListingService,
    private transferState: TransferState,
    @Inject(PLATFORM_ID) private platformId
  ) {}

  resolve(): Observable<Category[]> {
    const LASTADDED_KEY = makeStateKey<Category[]>('lastAdded');
    const startTime = performance.now();
    if (this.transferState.hasKey(LASTADDED_KEY)) {
      const lastAdded = this.transferState.get(LASTADDED_KEY, null);
      this.transferState.remove(LASTADDED_KEY);
      return of(lastAdded);
    } else {
      return this.listingService.lastAddedVenues().pipe(
        tap(lastAdded => {
          const endTime = performance.now();
        // console.log(`Resolver execution time: ${endTime - startTime} ms`);
          if (isPlatformServer(this.platformId)) {
            this.transferState.set(LASTADDED_KEY, lastAdded);
          }
        })
      );
    }
  }
}
